import { iconProps } from '../types/icon';

const IconPhone = ({ size="32", fill="currentColor"}: iconProps) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path fill={fill} d="M9.94,25.92h11.03V6.08h-11.03v19.85ZM12.46,22.93c.21-.21.47-.32.79-.32h4.41c.31,0,.57.11.79.32.21.21.32.47.32.79s-.11.57-.32.79-.47.32-.79.32h-4.41c-.31,0-.57-.11-.79-.32-.21-.21-.32-.47-.32-.79s.11-.57.32-.79Z"/>
    <path fill={fill} d="M29.63,0H2.36C1.06,0,0,1.03,0,2.31v27.39c0,1.28,1.06,2.31,2.36,2.31h27.27c1.3,0,2.37-1.03,2.37-2.31V2.31C32,1.03,30.93,0,29.63,0ZM24.27,13.24c0,.35-.1.66-.3.94-.2.28-.47.48-.8.61v11.14c0,.61-.22,1.13-.65,1.56-.43.43-.95.65-1.56.65h-11.03c-.61,0-1.13-.22-1.56-.65s-.65-.95-.65-1.56V6.08c0-.61.22-1.13.65-1.56s.95-.65,1.56-.65h11.03c.61,0,1.13.22,1.56.65.43.43.65.95.65,1.56v3.42c.33.13.6.33.8.61.2.28.3.59.3.94v2.21Z"/>
  </svg>
);

export default IconPhone;
